import { httpPost } from './request/index'

// 溧水厨余计重--列表
export function foodWasteList (data) {
  return httpPost('foodwasteWeight/getList', data)
}

// 溧水厨余计重--新增
export function foodWasteAdd (data) {
  return httpPost('foodwasteWeight/edit', data)
}

// 小区设备--列表查询
export function plotDeviceList (data) {
  return httpPost('foodwasteWeight/estateCount', data)
}

// 小区设备--列表查询
export function plotDeviceDetails (data) {
  return httpPost('foodwasteWeight/details', data)
}

// 小区设备--统计列表
export function statisticsList (data) {
  return httpPost('foodwasteWeight/statistics', data)
}

// 分类参与统计--列表
export function getRate (data) {
  return httpPost('foodwasteWeight/getRate', data)
}

// 分类参与统计--统计
export function participationCount (data) {
  return httpPost('foodwasteWeight/districData', data)
}

export function participationRate (data) {
  return httpPost('foodwasteWeight/getDetailsNum', data)
}

// 以下从监管移入过来
// 当日满意度统计
export function getScoreStatistics (data) {
  return httpPost('/data/getScoreStatistics', data)
}
// 空气质量满意度
export function getQuality (data) {
  return httpPost('/data/getQuality', data)
}
// 运营规范满意度
export function getStandard (data) {
  return httpPost('/data/getStandard', data)
}
// 设备体验满意度
export function getConvenient (data) {
  return httpPost('/data/getConvenient', data)
}
// 内外部环境满意度
export function getTidy (data) {
  return httpPost('/data/getTidy', data)
}

// 点位查询
export function getPointList (data) {
  return httpPost('/product/getPointList', data)
}
// 运营数据分析--列表
export function getScoreList (data) {
  return httpPost('product/getScoreList', data)
}
// 数据分析 > 成本数据分析
export function getDataOperatingCost (data) {
  return httpPost('/data/getOperatingCost', data)
}
